module.exports = __webpack_public_path__ + "static/img/CYtu6@2x.f94a3791.png";